import React from 'react';
import FireFlowFlowHydrantTableRow from './FireFlowFlowHydrantTableRow';

const FireFlowFlowHydrantList = ({ flowHydrants }) => {

  const rows = flowHydrants?.map((h, idx) => (<FireFlowFlowHydrantTableRow key={h.hydrantId} number={idx + 1} flowHydrant={h} />));

  return (
    <table className="table border-thick">
      <thead>
        <tr>
          <th></th>
          <th>Flow Hydrant</th>
          <th>Flow Device</th>
          <th>Diameter</th>
          <th>GPM</th>
          <th>Gallons Used</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>
  );
};

export default FireFlowFlowHydrantList;